import { FunctionField, ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import Tooltip from '@mui/material/Tooltip';
import startCase from 'lodash/startCase';
import { ActionButton } from '@/components/buttons';
import { LinkStyled, MainDatagridStyled } from '@/styles/overrides';
import { OneOffCheckRecord } from '@/types/turn-api';
import { TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import ConnectReport from './ConnectReport';
import { path, SORT_OPTIONS } from './constants';
import RequestOneOffCheck from './RequestOneOff';
import { ActionButtonStyled, CheckNameContainer } from './styled';
import useController from './useController';

const OneOffChecksTab = (props: Partial<TabProps>) => {
  const {
    checks,
    closeForm,
    handleOnEdit,
    handleOnEditConnectReport,
    openForm,
    record,
    showForm,
    showConnectReport,
    worker,
  } = useController();

  return (
    <Tab label="Custom Checks" {...props}>
      {showForm ? (
        <RequestOneOffCheck checks={checks} onClose={closeForm} record={record} worker={worker} />
      ) : showConnectReport ? (
        <ConnectReport onClose={closeForm} record={record} worker={worker} />
      ) : (
        <>
          <ActionButtonStyled iconType="addCircleOutline" label="Request Custom Check" onClick={openForm} />

          <ReferenceManyField
            label=""
            reference={TurnReferencesEnum.Candidates}
            sort={SORT_OPTIONS}
            target={TurnTargetsEnum.OneOffChecks}
          >
            <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
              <FunctionField
                label="Check"
                render={(record: OneOffCheckRecord.Base) => {
                  const connectReport = record?.connect_order_report;
                  return (
                    <CheckNameContainer>
                      <span>{startCase(record.name)}</span>
                      {connectReport ? <small>Connect Order ID: {connectReport.connect_order_id}</small> : null}
                    </CheckNameContainer>
                  );
                }}
              />
              <TextField label="Status" source={path('state')} />
              <TextField label="Resolution" source={path('resolution')} />
              <FunctionField
                label="Report URL"
                sortable={false}
                render={(row: OneOffCheckRecord.Base) =>
                  row.report_url ? (
                    <Tooltip title={row.report_url}>
                      <LinkStyled href={row.report_url} target="_blank" rel="noopener noreferrer">
                        View Report
                      </LinkStyled>
                    </Tooltip>
                  ) : null
                }
              />
              <FunctionField
                render={(record: OneOffCheckRecord.Base) => (
                  <ActionButton label="Edit Check" onClick={() => handleOnEdit(record)} renderIcon={false} />
                )}
                label=""
              />
              <FunctionField
                render={(record: OneOffCheckRecord.Base) =>
                  record.connect_order_report ? (
                    <ActionButton
                      label="Edit Connect Report"
                      onClick={() => handleOnEditConnectReport(record)}
                      renderIcon={false}
                    />
                  ) : null
                }
                label=""
              />
            </MainDatagridStyled>
          </ReferenceManyField>
        </>
      )}
    </Tab>
  );
};

export default OneOffChecksTab;
